import React, { FormEvent, ChangeEvent } from "react";
import { Box, Button, TextField, CircularProgress } from "@mui/material";
import { useAppContext } from "../../../../context/AppContext";
import { COMMON_MUI_STYLES } from "../../../../styles";
import { PasswordField } from "./PasswordField";

interface LoginFormProps {
  email: string;
  password: string;
  showPassword: boolean;
  loginErrors: { [key: string]: string };
  isLoading: boolean;
  onEmailChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onPasswordChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onTogglePassword: () => void;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
  onForgotPasswordClick: () => void;
}

export const LoginForm: React.FC<LoginFormProps> = ({
  email,
  password,
  showPassword,
  loginErrors,
  isLoading,
  onEmailChange,
  onPasswordChange,
  onTogglePassword,
  onSubmit,
  onForgotPasswordClick,
}) => {
  const { getTranslation } = useAppContext();

  return (
    <Box
      component="form"
      onSubmit={onSubmit}
      noValidate
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        justifyContent: "start",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          width: { xs: "90%", sm: "70%", md: "35%" },
        }}
      >
        <TextField
          margin="normal"
          fullWidth
          id="email"
          placeholder={getTranslation("Txt7").replace(" *", "")}
          name="email"
          autoComplete="email"
          value={email}
          onChange={onEmailChange}
          error={!!loginErrors.email}
          helperText={loginErrors.email}
          sx={COMMON_MUI_STYLES.textField}
        />
        <PasswordField
          name="password"
          placeholder={getTranslation("Txt8")}
          value={password || ""}
          onChange={onPasswordChange}
          showPassword={showPassword}
          onTogglePassword={onTogglePassword}
          error={!!loginErrors.password}
          helperText={loginErrors.password}
        />
        <Box sx={{ width: "100%", textAlign: "right", mt: 1 }}>
          <Button
            onClick={onForgotPasswordClick}
            variant="text"
            size="medium"
            sx={{
              textTransform: "none",
              color: "var(--color-text-primary)",
              fontWeight: 500,
              p: 0,
              minWidth: 0,
              textDecoration: "underline",
              "&:hover": {
                textDecoration: "underline",
                backgroundColor: "transparent",
              },
            }}
          >
            {getTranslation("Txt9")}
          </Button>
        </Box>
      </Box>
      <Button
        type="submit"
        variant="contained"
        disabled={isLoading}
        sx={{
          width: { xs: "90%", sm: "70%", md: "35%" },
          mt: 3,
          mb: 2,
          ...COMMON_MUI_STYLES.button,
        }}
      >
        {isLoading ? (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <CircularProgress size={20} sx={{ color: "var(--color-text-inverse)" }} />
          </Box>
        ) : (
          getTranslation("Txt10")
        )}
      </Button>
    </Box>
  );
};
